import { createBrowserClient } from '@supabase/ssr';

// Single shared Supabase client instance — prevents "Multiple GoTrueClient instances" warning
export const supabase = createBrowserClient(
  process.env.NEXT_PUBLIC_SUPABASE_URL!,
  process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY!
);
